import { render, staticRenderFns } from "./DeleteFarm.vue?vue&type=template&id=b1fcb700&"
import script from "./DeleteFarm.vue?vue&type=script&lang=ts&"
export * from "./DeleteFarm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports